import { render } from "./Obras.vue?vue&type=template&id=3d0d99f4&scoped=true"
import script from "./Obras.vue?vue&type=script&lang=js"
export * from "./Obras.vue?vue&type=script&lang=js"

import "./Obras.vue?vue&type=style&index=0&id=3d0d99f4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3d0d99f4"

export default script